// Icon — references the inline SVG sprite in index.html (the design's line-icon
// set). Styled by the .ic rules in styles.css (stroke = currentColor).
// Usage: <Icon name="send" />  ·  names: bell logout settings back close smile
// image mic send trash play pause clip edit stop search plus refresh
export default function Icon({ name, className = "" }) {
  return (
    <svg className={`ic ${className}`} aria-hidden="true" focusable="false">
      <use href={`#ic-${name}`} />
    </svg>
  );
}
